import styled from 'styled-components'

import { colors } from '../../../../../../shared/styles/colors'

export const Title = styled.div`
  font-family: 'Roboto';
  font-style: italic;
  font-size: 16px;
  font-weight: 700;
  color: ${colors.green};
  margin-bottom: 20px;
  padding-left: 12px;
  padding-top: 40px;
`
export const TitleModal = styled.h2`
  font-family: 'Roboto';
  font-size: 24px;
  font-weight: 700;
  color: ${colors.black};
  margin-bottom: 20px;
  padding-left: 12px;
  padding-top: 40px;
  margin: 0 auto;
`

export const Label = styled.div`
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: start;

  color: ${colors.blue};
  padding: 24px 0;
  padding-left: 32px;
`

export const FormSliderStyled = styled.div`
  width: 80%;
`

interface ContainerProps {
  height: string
}
export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  width: auto;
  height: ${props => props.height};
  background-color: #ffffff;
  overflow-y: auto;
  box-shadow: 0px 3px 3px rgb(0 0 0 / 25%);
  border-radius: 8px;
  margin-bottom: 24px;
`
export const ContainerBorder = styled.div`
  display: flex;
  flex-direction: column;
  width: auto;
  margin: 30px;
  background-color: #ffffff;
  border-radius: 4px;
  border: 1px solid ${colors.stepInactive};
`

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

export const ContainerNovoBoleto = styled.div`
  padding: 32px 64px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const Message = styled.div`
  width: 100%;
  height: 100%;
`

export const ContainerText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const TextItem = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: ${colors.black};
  padding-bottom: 16px;
  padding-left: 16px;
`

export const LabelItem = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: ${colors.black};
  padding-top: 16px;
  padding-left: 16px;
`

export const TextInfo = styled.p`
  font-size: 12px;
  font-weight: 400;
  padding-bottom: 8px;
  margin: 0 30px;
`
export const ContainerTabs = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 20px;
`
